import { Typography, TypographyProps } from '@mui/material';
import { Link, useTranslate } from 'react-admin';

export const AppBarTitle = (props: TypographyProps) => {
  const translate = useTranslate();
  return (
    <Link 
      to="/" 
      style={{ 
        textDecoration: 'none',
      }}
      color="inherit"
      flex="1"
    >
      <Typography
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        overflow="hidden"
        variant="body1"
        paddingLeft={8}
      >
        {translate('pos.app_title')}
      </Typography>
    </Link>
  );
};
